import { MdFullscreen } from "react-icons/md";
import useFetch from "../../../hooks/useFetch";
import request from "../../../utils/request";
import toggleFullscreen from "../../../utils/toggleFullScreen";
import { Col, Row, Table } from "react-bootstrap";
import usePatientFormStore from "../../../hooks/usePatientFormStore";

const FormDataShowInSecondScreen = () => {
  const { data: settingsData } = useFetch(() => request.getAll("settings"));
  const settingData = settingsData[0];
  const { formData } = usePatientFormStore();
  console.log("formData", formData);

  const formInputField = [
    { id: 1, label: "Introducer", name: "introducer" },
    { id: 2, label: "Full Name", name: "f_name" },
    { id: 3, label: "Father's Name", name: "father_name" },
    { id: 4, label: "Mother's Name", name: "mother_name" },
    { id: 5, label: "Passport Number", name: "passport_no" },
    { id: 6, label: "Date of Birth", name: "date_of_birth" },
    { id: 19, label: "Gender", name: "gender" },
    { id: 20, label: "Marital Status", name: "marital_status" },
    { id: 21, label: "Profession", name: "profession" },
    { id: 7, label: "Country", name: "country" },
    { id: 8, label: "Remarks", name: "remarks" },
    { id: 9, label: "Address", name: "address_1" },
    { id: 10, label: "Mobile", name: "mobile" },
    { id: 11, label: "Religion", name: "religion" },
    { id: 12, label: "PI Place", name: "pi_place" },
    { id: 13, label: "PI Date", name: "pi_date" },
    { id: 14, label: "PE Date", name: "pe_date" },
    { id: 15, label: "Visa Number", name: "visa_no" },
    { id: 16, label: "Visa Date", name: "visa_date" },
    { id: 17, label: "GCC Slip Number", name: "gcc_slip_no" },
    { id: 18, label: "GCC Expiry Date", name: "gcc_expairy_date" },
  ];

  const firstInputField = formInputField.slice(0, 10);
  const secondInputField = formInputField.slice(10);

  return (
    <div>
      <div className="d-flex justify-content-between  text-white p-4 bg-cyan">
        <div className="fs-3">Clincx Token</div>
        <div className="d-flex gap-3 align-items-center">
          <p className="m-0 p-0 fs-3">{settingData?.website_name}</p>
          <div className="cursor-pointer" onClick={toggleFullscreen}>
            <MdFullscreen size={40} />
          </div>
        </div>
      </div>

      <div className="mx-5 mt-4">
        <div className="d-flex gap-3">
          <div>
            <img
              src={formData?.img || "/userimg.png"}
              // name='image'
              alt="user_photo"
              className="img-fluid rounded-3 "
              style={{ width: "10rem", height: "10rem" }}
            />
            <p>User Photo</p>
          </div>
          {/* "no-fingerprint.jpg" */}

          <div>
            <img
              src={formData?.fingerprint || "no-fingerprint.jpg"}
              // name='image'
              alt="fingerprint"
              className="img-fluid rounded-3 "
              style={{ width: "10rem", height: "10rem" }}
            />
            <p>Fingerprint</p>
          </div>
        </div>

        <Row className="mt-3">
          <Col sm={12} md={6}>
            <Table striped bordered hover>
              <tbody>
                {firstInputField?.map((field) => (
                  <tr key={field.id} className="form-screen-tr">
                    <td style={{ width: "40%" }}>{field.label}</td>
                    <td>{formData[field.name]}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>

          <Col sm={12} md={6}>
            <Table striped bordered hover className="ms-3">
              <tbody>
                {secondInputField?.map((field) => (
                  <tr key={field.id} className="form-screen-tr">
                    <td style={{ width: "40%" }}>{field.label}</td>
                    <td>{formData[field.name]}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>

      {/* <div className="text-center text-white p-4 bg-cyan position-absolute bottom-0 w-100"> */}
      {/*   Powerd By Clincx Medical Solution */}
      {/* </div> */}
    </div>
  );
};
export default FormDataShowInSecondScreen;
